import type * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MarkEvaluationSeenMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type MarkEvaluationSeenMutation = { __typename?: 'RootMutationType', markEvaluationSeen: { __typename?: 'MarkEvaluationSeenResult', result?: { __typename?: 'StudentAssignment', id: string, studentHasSeenEvaluation: boolean } | null, errors: Array<{ __typename?: 'MutationError', message?: string | null }> } };


export const MarkEvaluationSeenDocument = gql`
    mutation MarkEvaluationSeen($id: ID!) {
  markEvaluationSeen(id: $id) {
    result {
      id
      studentHasSeenEvaluation
    }
    errors {
      message
    }
  }
}
    `;
export type MarkEvaluationSeenMutationFn = Apollo.MutationFunction<MarkEvaluationSeenMutation, MarkEvaluationSeenMutationVariables>;

/**
 * __useMarkEvaluationSeenMutation__
 *
 * To run a mutation, you first call `useMarkEvaluationSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkEvaluationSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markEvaluationSeenMutation, { data, loading, error }] = useMarkEvaluationSeenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkEvaluationSeenMutation(baseOptions?: Apollo.MutationHookOptions<MarkEvaluationSeenMutation, MarkEvaluationSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkEvaluationSeenMutation, MarkEvaluationSeenMutationVariables>(MarkEvaluationSeenDocument, options);
      }
export type MarkEvaluationSeenMutationHookResult = ReturnType<typeof useMarkEvaluationSeenMutation>;
export type MarkEvaluationSeenMutationResult = Apollo.MutationResult<MarkEvaluationSeenMutation>;
export type MarkEvaluationSeenMutationOptions = Apollo.BaseMutationOptions<MarkEvaluationSeenMutation, MarkEvaluationSeenMutationVariables>;